// @ts-nocheck
/* eslint no-console: off */

import { getCurrentSessionURL } from 'react-scale/lib/fullstory';
import uuid from 'uuid';

let lastEventId: string | undefined;

function createErrorId() {
  lastEventId = uuid.v4();
  return lastEventId;
}

export async function captureServerSideError(
  result,
  type,
  ignorableStatusCodes: number[] = [],
  extra = {},
  level = 'error',
) {
  const isAnomalousError =
    ignorableStatusCodes.indexOf(result.status) === -1 && typeof window !== 'undefined';

  if (isAnomalousError) {
    const id = createErrorId();
    const resultData = {
      id,
      status: result.status,
      statusText: result.statusText,
    };

    try {
      resultData.body = await result.text();
    } catch (err) {
      resultData.body = `Error obtaining server-side error response text: ${err.message}`;
    }

    const fullstorySession = getCurrentSessionURL(true);
    const mergedResult = { type, level, ...resultData, ...extra, fullstorySession };

    console.warn('server-side error captured', mergedResult);

    return resultData.body;
  } else {
    try {
      return await result.text();
    } catch (err) {
      console.warn(`Error getting error text for error ${result.status} ${result.statusText}`, err);
      return 'An error has occurred';
    }
  }
}

/**
 * Capture an error in a front-end ts.
 *
 * params:
 *  - exception: The exception that occurred
 *  - errorType: A tag that represents the category of error. This is separate from
 *       severity and could be anything. The recommendation is to set this to value
 *       that describes the feature. Defaults to 'generic'
 *  - extra: Set directly in the extra field. (Deprecated) Automatically adds fullstory session
 *       as an extra.
 *  - level: The severity of the issue. Defaults to 'error'
 *  - tags: Additional tags. Suggested tags are 'engTeam' and 'taskType'
 *       to assist with exception routing
 */
export function captureClientSideError(
  exception,
  errorType = 'generic',
  extra = {},
  level = 'error',
  tags = {},
) {
  if (typeof window !== 'undefined') {
    // XXX fullstory session should be a tag
    // TODO: follow-up on https://github.com/scaleapi/scaleapi/pull/5037 and add fullstorysession as a tag in every root container
    // TODO: remove fullstorySession from this fn
    const fullstorySession = getCurrentSessionURL(true);

    const id = createErrorId();
    const mergedExtras = { id, errorType, level, fullstorySession, ...extra, tags };
    console.error('client-side error captured', exception, mergedExtras);
    return getLastEventId();
  }

  console.warn('client-side error captured', exception, extra);
}

export function captureMessage(message, context) {
  if (typeof window !== 'undefined') {
    if (!context) {
      context = {};
    }
    if (!context.extra) {
      context.extra = {};
    }
    context.id = createErrorId();

    console.error('client-side message captured', message, context);
    context.extra.fullstorySession = getCurrentSessionURL(true);
  }

  console.warn(message, context);
}

export function getLastEventId() {
  return lastEventId;
}
